// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { productAvailabilityStyles } from "@sc/Overrides/Components/ProductAvailability";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import { css } from "styled-components";

productAvailabilityStyles.totalAvailabilityWrapper = {
    css: css`
        display: flex;
        align-items: self-start;
        gap: 8px;
        & > ${IconWrapper} {
            margin-top: 1px;
        }
    `,
};

productAvailabilityStyles.inBranchAvailabilityWrapper = {
    css: css`
        display: flex;
        align-items: self-start;
        gap: 8px;
        & > ${IconWrapper} {
            margin-top: 1px;
        }
    `,
};

productAvailabilityStyles.inventoryOutOfStockPickupWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
        .inventory-out-of-stock-pickup {
            font-size: 12px;
            line-height: 14px;
        }
    `,
};

productAvailabilityStyles.totalAvailableSmallHeading = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                width: auto;
            `,
        },
        heading: {
            ...TRANSLATE_OBJECT as any,
            css: css`
                && {
                    line-height: 14px;
                }
            `,
        },
        text: {
            ...TRANSLATE_OBJECT as any,
            css: css`
                && {
                    line-height: 14px;
                }
            `,
        },
    }),
};

productAvailabilityStyles.messageGridItem = {
    width: 12,
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productAvailabilityStyles.messageText = {
    size: 12,
    lineHeight: "14px",
    weight: "bold",
};

productAvailabilityStyles.pdpMessageText = {
    size: 12,
    lineHeight: "14px",
    weight: "normal",
};

productAvailabilityStyles.availabilityMessageText = {
    size: 14,
    weight: "normal",
    lineHeight: "22px",
};

productAvailabilityStyles.notAvailabilityInWarehouseTableCell = {
    colSpan: 4,
    css: css`
        padding: 10px 0;
    `,
};
productAvailabilityStyles.availabilityByWarehouseLink = {
    css: css`
        margin-top: 8px;
    `, 
}